/**
 * Corps ticket duplicata — même rendu écran et impression (iPad / PC).
 */
export default function DuplicataTicketBody({ model, testIdPrefix = 'caisse-duplicata' }) {
  if (!model) return null;
  return (
    <div className="text-sm font-mono text-slate-900" data-testid={`${testIdPrefix}-body`}>
      {model.merchantLines?.length > 0 && (
        <div
          className="text-center mb-3 space-y-0.5 text-xs leading-snug"
          data-testid={`${testIdPrefix}-merchant`}
        >
          {model.merchantLines.map((line, i) => (
            <div key={`m-${i}`} className={i === 0 ? 'font-bold text-sm text-slate-900' : 'text-slate-700'}>
              {line}
            </div>
          ))}
        </div>
      )}
      <p
        className="text-center font-bold text-red-600 mb-2"
        data-testid={`${testIdPrefix}-banner`}
      >
        --- DUPLICATA ---
      </p>
      <p className="text-center font-semibold text-slate-900">Ticket {model.numero}</p>
      <p className="text-center text-xs text-slate-500 mb-3">{model.dateLabel}</p>
      <table className="w-full border-collapse">
        <tbody>
          {model.lignes.map((l) => (
            <tr key={l.id} className="border-b border-dashed border-slate-300">
              <td className="py-1.5 pr-2 align-top">{l.nom}</td>
              <td className="py-1.5 text-center whitespace-nowrap align-top">x{l.quantite}</td>
              <td className="py-1.5 text-right whitespace-nowrap align-top">{l.montant}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {model.fideliteLines.length > 0 && (
        <div className="mt-3 pt-2 border-t border-dashed border-slate-400 space-y-1 text-xs">
          {model.fideliteLines.map((line, i) => (
            <div key={`fid-${i}`}>{line}</div>
          ))}
        </div>
      )}
      {model.paiements.length > 0 && (
        <div className="mt-3 pt-2 border-t border-slate-800">
          <p className="font-semibold text-xs mb-1">Paiements</p>
          {model.paiements.map((p) => (
            <div key={p.id} className="flex justify-between text-xs py-0.5 gap-2">
              <span>{p.methode}</span>
              <span className={p.montantRaw < 0 ? 'text-red-700' : ''}>{p.montant}</span>
            </div>
          ))}
        </div>
      )}
      {model.refundSynthesis && (
        <div
          className="mt-3 pt-2 border-t border-dashed border-slate-500 space-y-1 text-xs"
          data-testid={`${testIdPrefix}-refund-synthesis`}
        >
          <p className="font-semibold text-slate-800">Synthèse remboursements (information)</p>
          <div className="flex justify-between gap-2">
            <span className="text-slate-600">Vente initiale</span>
            <span>{model.refundSynthesis.venteInitialeLabel}</span>
          </div>
          <div className="flex justify-between gap-2">
            <span className="text-slate-600">Remboursements</span>
            <span className="text-red-700">{model.refundSynthesis.remboursementsLabel}</span>
          </div>
          <div className="flex justify-between gap-2 font-semibold">
            <span>Net après remboursements</span>
            <span>{model.refundSynthesis.netLabel}</span>
          </div>
          <p className="text-[10px] text-slate-500 pt-1">
            Duplicata — pas un avoir fiscal officiel (L3-S4).
          </p>
        </div>
      )}
      {model.showArticlesRetournes && (
        <div
          className="mt-3 pt-2 border-t border-dashed border-slate-400"
          data-testid={`${testIdPrefix}-articles-retournes`}
        >
          <p className="font-semibold text-xs mb-2 text-slate-800">Articles retournés — information</p>
          <ul className="space-y-2 text-xs">
            {model.articlesRetournes.map((r) => (
              <li key={r.lineId} className="border-b border-dashed border-slate-200 pb-2">
                <p className="font-medium">{r.nom}</p>
                <p className="text-slate-600">
                  Vendu {r.quantiteVendue} · Retourné{' '}
                  <span className="line-through decoration-red-400">{r.quantiteRetournee}</span> · Conservé{' '}
                  {r.quantiteConservee}
                </p>
                <p className="text-right text-slate-800">{r.montantRetourLabel}</p>
              </li>
            ))}
          </ul>
          <p className="text-[10px] text-slate-500 mt-2">{model.articlesRetournesDisclaimer}</p>
        </div>
      )}
      <p
        className="text-center font-bold text-base mt-3 pt-2 border-t-2 border-slate-900"
        data-testid={`${testIdPrefix}-total-origine`}
      >
        TOTAL VENTE INITIALE : {model.totalLabel}
      </p>
      <p
        className={`text-center text-xs mt-2 ${model.annule ? 'font-bold text-red-600' : 'text-slate-600'}`}
        data-testid={`${testIdPrefix}-footer`}
      >
        {model.footerMerci}
      </p>
    </div>
  );
}
